import {
    APIMajorVersions,
    APIV1MinorVersions,
    APIV2MinorVersions,
    BackEndEnvironmentUrls,
    LATEST_V1_MINOR_VERSION,
    LATEST_V2_MINOR_VERSION,
    SwaggerUIBaseParams
} from "../Assets/variables";
import { backEndEnvironmentToUse } from "./environmentHelpers";

export function parseApiSchemas(openApiSpecification, apiName) {
    let contentFields = {};

    Object.keys(openApiSpecification.paths).forEach(path => {
        let currentEndPoint = openApiSpecification.paths[path];

        let pathTopLevel = !!currentEndPoint?.get
            ? currentEndPoint?.get?.responses["200"].content["application/json"].schema["$ref"].split("/").slice(-1)[0]
            : currentEndPoint?.post?.responses["200"].content["application/json"].schema["$ref"].split("/").slice(-1)[0];

        parseFromTopLevel(pathTopLevel, openApiSpecification.components.schemas, contentFields, path, apiName);
    });

    if (Object.keys(contentFields).length >= 2) {
        for (let i = Object.keys(contentFields).length; i > 0; i--) {
            let isDuplicate = false;

            for (let k = i - 1; k > 0; k--) {
                if (JSON.stringify(contentFields[Object.keys(contentFields)[i - 1]]) === JSON.stringify(contentFields[Object.keys(contentFields)[k - 1]])) {
                    isDuplicate = true;
                }
            }

            if (isDuplicate) {
                delete contentFields[Object.keys(contentFields)[i - 1]];
            }
        }
    }

    return contentFields;
};

function parseFromTopLevel(topLevelRef, openApiSpecificationSchemas, contentFields, path, apiName) {
    let currentSchema = extractSchemaName(openApiSpecificationSchemas[topLevelRef].properties.data["$ref"]);
    let finalSchema;
    contentFields[path] = {};

    if (openApiSpecificationSchemas[currentSchema].properties[Object.keys(openApiSpecificationSchemas[currentSchema].properties)[0]].hasOwnProperty("items")) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[currentSchema].properties[Object.keys(openApiSpecificationSchemas[currentSchema].properties)[0]].items["$ref"]);
    } else {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[currentSchema].properties[Object.keys(openApiSpecificationSchemas[currentSchema].properties)[0]]["$ref"]);
    }

    finalSchema = parseByDataType(openApiSpecificationSchemas[finalSchema].properties);

    if (!!(openApiSpecificationSchemas[finalSchema]) && openApiSpecificationSchemas[finalSchema].properties[Object.keys(openApiSpecificationSchemas[finalSchema].properties)[0]].hasOwnProperty("items")) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[finalSchema].properties[Object.keys(openApiSpecificationSchemas[finalSchema].properties)[0]].items["$ref"]);
    } else if (!!(openApiSpecificationSchemas[finalSchema]) && openApiSpecificationSchemas[finalSchema].properties.hasOwnProperty(apiName)) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[finalSchema].properties[apiName]["$ref"]);
    } else if (!!(openApiSpecificationSchemas[finalSchema]) && openApiSpecificationSchemas[finalSchema].properties.hasOwnProperty("instruments")) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[finalSchema].properties["instruments"]["$ref"]);
    } else if (!!(openApiSpecificationSchemas[finalSchema]) && openApiSpecificationSchemas[finalSchema].properties.hasOwnProperty("listings")) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[finalSchema].properties["listings"]["$ref"]);
    }

    if (!!(openApiSpecificationSchemas[finalSchema]) && openApiSpecificationSchemas[finalSchema].properties[Object.keys(openApiSpecificationSchemas[finalSchema].properties)[0]].hasOwnProperty("items")) {
        finalSchema = extractSchemaName(openApiSpecificationSchemas[finalSchema].properties[Object.keys(openApiSpecificationSchemas[finalSchema].properties)[0]].items["$ref"]);
    }

    if (!!openApiSpecificationSchemas[finalSchema]) {
        setContentFieldsToBeDisplayed(openApiSpecificationSchemas[finalSchema].properties, openApiSpecificationSchemas, contentFields[path]);
    } else {
        setContentFieldsToBeDisplayed(finalSchema, openApiSpecificationSchemas, contentFields[path]);
    }

    return contentFields;
}

function setContentFieldsToBeDisplayed(properties, openApiSpecificationSchemas, contentFields) {
    Object.keys(properties).forEach(field => {
        let firstLevelField = contentFieldTitleTransformer(field);
        firstLevelField = acronymTransformer(firstLevelField);

        if (properties[field].hasOwnProperty("$ref") && !(properties[field].hasOwnProperty("deprecated"))) {
            contentFields[firstLevelField] = {
                title: firstLevelField,
                fieldName: field,
                type: properties[field].type,
                description: properties[field].description ? properties[field].description : "",
            };
            getNestedContentField(extractSchemaName(properties[field]["$ref"]), field, openApiSpecificationSchemas, contentFields);
        } else if (properties[field].hasOwnProperty("$ref") && properties[field].hasOwnProperty("description") && !(properties[field].hasOwnProperty("deprecated"))) {
            getNestedContentField(extractSchemaName(properties[field]["$ref"]), field, openApiSpecificationSchemas, contentFields);
        } else if (!!properties[field]["items"] && !!properties[field]["items"]["$ref"] && properties[field].hasOwnProperty("description") && !(properties[field].hasOwnProperty("deprecated"))) {
            contentFields[firstLevelField] = {
                title: firstLevelField,
                fieldName: field,
                type: properties[field].type,
                description: properties[field].description ? properties[field].description : "",
            };
            getNestedContentField(extractSchemaName(properties[field]["items"]["$ref"]), field, openApiSpecificationSchemas, contentFields);
        } else if (properties[field].hasOwnProperty("description") && !(properties[field].hasOwnProperty("deprecated"))) {
            contentFields[firstLevelField] = {
                title: firstLevelField,
                fieldName: field,
                description: properties[field].description ? properties[field].description : "",
                type: properties[field].type ? properties[field].type : "",
                enum: properties[field].enum ? properties[field].enum : "",
            }

            if (properties[field]?.format) {
                contentFields[firstLevelField].format = properties[field].format;
            }
        }
    })
}

function parseByDataType(schemaProperties) {
    if (schemaProperties.hasOwnProperty("referenceData")) {
        return extractSchemaName(schemaProperties.referenceData["$ref"]);
    } else if (schemaProperties.hasOwnProperty("marketData")) {
        return extractSchemaName(schemaProperties.marketData["$ref"]);
    } else if (schemaProperties && schemaProperties.freeTextSearch) {
        return extractSchemaName(schemaProperties.freeTextSearch["$ref"]);
    } else if (schemaProperties && schemaProperties.criteriaSearch) {
        return extractSchemaName(schemaProperties.criteriaSearch["$ref"]);
    } else if (schemaProperties && schemaProperties.news) {
        return extractSchemaName(schemaProperties.news["$ref"]);
    } else if (schemaProperties && schemaProperties.tax) {
        return extractSchemaName(schemaProperties.tax["$ref"]);
    } else if (schemaProperties && schemaProperties.investorProtection) {
        return extractSchemaName(schemaProperties.investorProtection["$ref"]);
    } else {
        return schemaProperties;
    }
}

function getNestedContentField(schemaName, field, openApiSpecificationSchemas, contentFields) {
    let firstLevelField = contentFieldTitleTransformer(field);
    firstLevelField = acronymTransformer(firstLevelField);

    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].hasOwnProperty("deprecated"))) {
        contentFields[firstLevelField] = {
            title: firstLevelField,
            fieldName: field,
            description: openApiSpecificationSchemas[schemaName].description ? openApiSpecificationSchemas[schemaName].description : "",
            type: openApiSpecificationSchemas[schemaName].type ? openApiSpecificationSchemas[schemaName].type : "",
            enum: openApiSpecificationSchemas[schemaName].enum ? openApiSpecificationSchemas[schemaName].enum : "",
        }
    }
    
    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("properties")) {
        Object.keys(openApiSpecificationSchemas[schemaName].properties).forEach(field => {
            let secondLevelField = contentFieldTitleTransformer(field);
            secondLevelField = acronymTransformer(secondLevelField);

            if (!!(openApiSpecificationSchemas[schemaName].properties[field]["$ref"])) {
                contentFields[`${firstLevelField} / ${secondLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                };
                getSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["$ref"]), firstLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (openApiSpecificationSchemas[schemaName].properties[field]["$ref"] && openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                getSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["$ref"]), firstLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (!!openApiSpecificationSchemas[schemaName].properties[field]["items"] && !!openApiSpecificationSchemas[schemaName].properties[field]["items"]["$ref"] && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                contentFields[`${firstLevelField} / ${secondLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                    type: openApiSpecificationSchemas[schemaName].properties[field].type ? openApiSpecificationSchemas[schemaName].properties[field].type : "",
                };
                getSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["items"]["$ref"]), firstLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                contentFields[`${firstLevelField} / ${secondLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                    type: openApiSpecificationSchemas[schemaName].properties[field].type ? openApiSpecificationSchemas[schemaName].properties[field].type : "",
                    enum: openApiSpecificationSchemas[schemaName].properties[field].enum ? openApiSpecificationSchemas[schemaName].properties[field].enum : "",
                }

                if (openApiSpecificationSchemas[schemaName].properties[field]?.format) {
                    contentFields[`${firstLevelField} / ${secondLevelField}`].format = openApiSpecificationSchemas[schemaName].properties[field].format;
                }
            }
        })
    }
}

function getSubSubContentField(schemaName, firstLevelField, field, openApiSpecificationSchemas, contentFields) {
    let secondLevelField = contentFieldTitleTransformer(field);
    secondLevelField = acronymTransformer(secondLevelField);

    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].hasOwnProperty("deprecated"))) {
        contentFields[`${firstLevelField} / ${secondLevelField}`] = {
            title: `${firstLevelField} / ${secondLevelField}`,
            fieldName: field,
            description: openApiSpecificationSchemas[schemaName].description ? openApiSpecificationSchemas[schemaName].description : "",
            type: openApiSpecificationSchemas[schemaName].type ? openApiSpecificationSchemas[schemaName].type : "",
            enum: openApiSpecificationSchemas[schemaName].enum ? openApiSpecificationSchemas[schemaName].enum : "",
        }
    }
    
    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("properties")) {
        Object.keys(openApiSpecificationSchemas[schemaName].properties).forEach(field => {
            let thirdLevelField = contentFieldTitleTransformer(field);
            thirdLevelField = acronymTransformer(thirdLevelField);

            if (!!(openApiSpecificationSchemas[schemaName].properties[field]["$ref"])) {
                contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                };
                getSubSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["$ref"]), firstLevelField, secondLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (openApiSpecificationSchemas[schemaName].properties[field]["$ref"] && openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                getSubSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["$ref"]), firstLevelField, secondLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("items") && openApiSpecificationSchemas[schemaName].properties[field]["items"].hasOwnProperty("$ref")) {
                getSubSubSubContentField(extractSchemaName(openApiSpecificationSchemas[schemaName].properties[field]["items"]["$ref"]), firstLevelField, secondLevelField, field, openApiSpecificationSchemas, contentFields);
            } else if (openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                    type: openApiSpecificationSchemas[schemaName].properties[field].type ? openApiSpecificationSchemas[schemaName].properties[field].type : "",
                    enum: openApiSpecificationSchemas[schemaName].properties[field].enum ? openApiSpecificationSchemas[schemaName].properties[field].enum : "",
                }

                if (openApiSpecificationSchemas[schemaName].properties[field]?.format) {
                    contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`].format = openApiSpecificationSchemas[schemaName].properties[field].format;
                }
            }
        })
    }
}

function getSubSubSubContentField(schemaName, firstLevelField, secondLevelField, field, openApiSpecificationSchemas, contentFields) {
    let thirdLevelField = contentFieldTitleTransformer(field);
    thirdLevelField = acronymTransformer(thirdLevelField);

    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].hasOwnProperty("deprecated"))) {
        contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`] = {
            title: `${firstLevelField} / ${secondLevelField} / ${thirdLevelField}`,
            fieldName: field,
            description: openApiSpecificationSchemas[schemaName].description ? openApiSpecificationSchemas[schemaName].description : "",
            type: openApiSpecificationSchemas[schemaName].type ? openApiSpecificationSchemas[schemaName].type : "",
            enum: openApiSpecificationSchemas[schemaName].enum ? openApiSpecificationSchemas[schemaName].enum : "",
        }
    }
    
    if (openApiSpecificationSchemas[schemaName].hasOwnProperty("properties")) {
        Object.keys(openApiSpecificationSchemas[schemaName].properties).forEach(field => {
            if (openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("description") && !(openApiSpecificationSchemas[schemaName].properties[field].hasOwnProperty("deprecated"))) {
                let fourthLevelField = contentFieldTitleTransformer(field);
                fourthLevelField = acronymTransformer(fourthLevelField);
    
                contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField} / ${fourthLevelField}`] = {
                    title: `${firstLevelField} / ${secondLevelField} / ${thirdLevelField} / ${fourthLevelField}`,
                    fieldName: field,
                    description: openApiSpecificationSchemas[schemaName].properties[field].description ? openApiSpecificationSchemas[schemaName].properties[field].description : "",
                    type: openApiSpecificationSchemas[schemaName].properties[field].type ? openApiSpecificationSchemas[schemaName].properties[field].type : "",
                    enum: openApiSpecificationSchemas[schemaName].properties[field].enum ? openApiSpecificationSchemas[schemaName].properties[field].enum : "",
                }

                if (openApiSpecificationSchemas[schemaName].properties[field]?.format) {
                    contentFields[`${firstLevelField} / ${secondLevelField} / ${thirdLevelField} / ${fourthLevelField}`].format = openApiSpecificationSchemas[schemaName].properties[field].format;
                }
            }
        })
    } 
}

function extractSchemaName(reference) {
    return reference.split("/").slice(-1)[0];
}

export function parseApiProperties(openApiSpecification) {
    let parameterFields = {};

    Object.keys(openApiSpecification.paths).forEach(path => {
        let currentEndPoint = openApiSpecification.paths[path];

        let apiParametersList = !!currentEndPoint?.get
            ? currentEndPoint?.get?.parameters
            : currentEndPoint?.post?.parameters;

        setPropertyFieldsToBeDisplayed(apiParametersList, parameterFields);
    });

    if (Object.keys(parameterFields).length >= 2) {
        for (let i = Object.keys(parameterFields).length; i > 0; i--) {
            let isDuplicate = false;

            for (let k = i - 1; k > 0; k--) {
                if (JSON.stringify(parameterFields[Object.keys(parameterFields)[i - 1]]) === JSON.stringify(parameterFields[Object.keys(parameterFields)[k - 1]])) {
                    isDuplicate = true;
                }
            }

            if (isDuplicate) {
                delete parameterFields[Object.keys(parameterFields)[i - 1]];
            }
        }
    }

    return parameterFields;
};

export function parseApiPropertiesByPath(openApiSpecification) {
    let parameterFields = {};

    Object.keys(openApiSpecification.paths).forEach(path => {
        let currentEndPoint = openApiSpecification.paths[path];

        let apiParametersList = !!currentEndPoint?.get
            ? currentEndPoint?.get?.parameters
            : currentEndPoint?.post?.parameters;

        setPropertyFieldsByPathToBeDisplayed(apiParametersList, parameterFields, path);
    });

    return parameterFields;
};

function setPropertyFieldsToBeDisplayed(apiParametersList, parameterFields) {
    Object.keys(apiParametersList).forEach(field => {
        let firstLevelField = contentFieldTitleTransformer(apiParametersList[field].name);
        firstLevelField = acronymTransformer(firstLevelField);

        if (apiParametersList[field].hasOwnProperty("name")) {
            parameterFields[firstLevelField] = {
                name: firstLevelField,
                parameterName: apiParametersList[field].name,
                required: apiParametersList[field].required,
                description: apiParametersList[field].description ? apiParametersList[field].description : "",
                type: apiParametersList[field].schema.type ? apiParametersList[field].schema.type : "",
                format: apiParametersList[field].schema.format ? apiParametersList[field].schema.format : ""
            };
        }

        if (apiParametersList[field].schema.hasOwnProperty("enum")) {
            parameterFields[firstLevelField]["enum"] = apiParametersList[field].schema.enum ? apiParametersList[field].schema.enum : "";
        }

        if (apiParametersList[field].schema.hasOwnProperty("items")) {
            parameterFields[firstLevelField]["enum"] = apiParametersList[field].schema.items?.enum ? apiParametersList[field].schema.items.enum : "";
        }
    })
}

function setPropertyFieldsByPathToBeDisplayed(apiParametersList, parameterFields, path) {
    parameterFields[path] = [];
    Object.keys(apiParametersList).forEach(field => {
        let firstLevelField = contentFieldTitleTransformer(apiParametersList[field].name);
        firstLevelField = acronymTransformer(firstLevelField);

        if (apiParametersList[field].hasOwnProperty("name")) {
            parameterFields[path][firstLevelField] = {
                name: firstLevelField,
                parameterName: apiParametersList[field].name,
                required: apiParametersList[field].required,
                description: apiParametersList[field].description ? apiParametersList[field].description : "",
                type: apiParametersList[field].schema.type ? apiParametersList[field].schema.type : "",
                format: apiParametersList[field].schema.format ? apiParametersList[field].schema.format : ""
            };
        }

        if (apiParametersList[field].schema.hasOwnProperty("enum")) {
            parameterFields[path][firstLevelField]["enum"] = apiParametersList[field].schema.enum ? apiParametersList[field].schema.enum : "";
        }

        if (apiParametersList[field].schema.hasOwnProperty("items")) {
            parameterFields[path][firstLevelField]["enum"] = apiParametersList[field].schema.items?.enum ? apiParametersList[field].schema.items.enum : "";
        }
    })
}

export function acronymTransformer(title) {
    let titleArray = title.split(" ");
    let transformedTitle = [];

    const acronymFieldNames = [ "Cfi", "Eusipa ", "Fisn", "Icma", "Gk", "Bc", "Six", "Isin", "Ipo", "Vwap", "Lei", "Figi", "Cusip", "Cins", "Wkn",
        "Sedol", "Mica", "Ebitda", "Ebit", "Sspa", "Etd", "Us", "Crd", "Ibt", "Eu", "Bme", "Eba", "Gics", "Icb", "Nace", "Naf", "Sic", "Id",
        "Sukuk", "Bbg", "Occ", "Irs", "Mic", "Dti", "Ii", "Mifid", "Da", "Mbspc", "Esg", "Bic", "Wa", "Emt", "Ucits", "Srri", "Priip", "Sri"
    ];

    titleArray.forEach(word => {
        acronymFieldNames.forEach(acronym => {
            if (word.includes(acronym)
                && !(word.includes("Status")) && !(word.includes("Previous")) && !(word.includes("Intrinsic")) && !(word.includes("Mid"))
                && !(word.includes("Bid")) && !(word.includes("Paid")) && !(word.includes("Liquid")) && !(word.includes("Identifier"))
                && !(word.includes("Valid")) && !(word.includes("Euronext")) && !(word.includes("European")) && !(word.includes("Eusipa"))
                && !(word.includes("Dated")) && !(word.includes("Date")) && !(word.includes("Daily")) && !(word.includes("Day"))
                && !(word.includes("Days")) && !(word.includes("Data")) && !(word.includes("Eurobond")) && !(word.includes("Warrant"))
            ) {
                word = word.replace(acronym, acronym.toUpperCase())
            }
        })
        transformedTitle.push(word);
    });

    return transformedTitle.join(" ");
}

export function contentFieldTitleTransformer(title) {
    return title.charAt(0).toUpperCase() + title.slice(1).replace(/([A-Z][A-Z][A-Z][A-Z]|[A-Z][A-Z][A-Z]|[A-Z]|[A-Z][A-Z])/g, " $1").replace(/([1-9][0-9][0-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9]|[0-9])/g, " $1");
};

export function capitalizeWord(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLocaleLowerCase();
}

export function replaceUnderscore(word) {
    return word.replaceAll("_", " ");
}

export function separateWords(word) {
    return word.replace(/([a-z])([A-Z])/g, '$1 $2').split(" ");
}

/**
 * Deep copy with every `default` of `null` or `""` removed. Swagger UI's sample generator prefers a
 * schema level `default` over generating from the schema - its check is `!== undefined` - so
 * `"default": null` collapsed whole examples to `null`, and `"default": ""` rendered every field as
 * `""` and stopped `$ref`s expanding (`"lookup": ""` instead of the object). Neither documents
 * anything, and an empty default pre-fills nothing in "Try it out". Meaningful defaults (`"ISIN"`,
 * `10`, `false`) are kept, so the test is limited to `null` and `""`.
 */
export function stripEmptyDefaults(node) {
    if (Array.isArray(node)) {
        return node.map(stripEmptyDefaults);
    }

    if (node === null || typeof node !== "object") {
        return node;
    }

    let strippedNode = {};

    Object.keys(node).forEach(key => {
        if (key === "default" && (node[key] === null || node[key] === "")) {
            return;
        }

        strippedNode[key] = stripEmptyDefaults(node[key]);
    });

    return strippedNode;
}

/**
 * Deep copy with property names inside `properties` maps trimmed of surrounding whitespace, and
 * `required` entries trimmed to match. The generated specifications carry `"marketHolidays "` -
 * trailing space - in `MarketHolidaysReferenceDataV2` and `ListingMarketHolidaysReferenceDataV2`,
 * and Swagger UI prints the key verbatim, documenting a field name the API does not return. Only
 * `properties` keys are renamed, since whitespace is legal in an arbitrary JSON key. A rename is
 * skipped when the trimmed name already exists, so `"x"` and `"x "` both survive.
 */
export function trimPropertyNames(node) {
    if (Array.isArray(node)) {
        return node.map(trimPropertyNames);
    }

    if (node === null || typeof node !== "object") {
        return node;
    }

    let trimmedNode = {};

    Object.keys(node).forEach(key => {
        let value = node[key];

        if (key === "properties" && value !== null && typeof value === "object" && !Array.isArray(value)) {
            let trimmedProperties = {};

            Object.keys(value).forEach(propertyName => {
                let trimmedName = propertyName.trim();
                let collides = trimmedName !== propertyName && Object.keys(value).includes(trimmedName);

                trimmedProperties[collides ? propertyName : trimmedName] = trimPropertyNames(value[propertyName]);
            });

            trimmedNode[key] = trimmedProperties;
            return;
        }

        if (key === "required" && Array.isArray(value)) {
            trimmedNode[key] = value.map(name => (typeof name === "string" ? name.trim() : trimPropertyNames(name)));
            return;
        }

        trimmedNode[key] = trimPropertyNames(value);
    });

    return trimmedNode;
}

/**
 * Deep copy with `{ type: "array", $ref }` rewritten to `{ type: "array", items: { $ref } }`, the
 * shape the specification meant. OpenAPI 3.0.1 requires the reference under `items`, and Swagger
 * UI's generator honours the local keywords and discards a sibling `$ref`: it saw `type: array`
 * with no `items` and emitted `[]`, which is why Market Holidays documented `"marketHolidays ": []`.
 * Narrow by design - only when `type` is `array`, `items` is absent and a `$ref` is present - so
 * arrays that already declare `items`, and plain `$ref` schemas, are untouched. An array with
 * neither cannot be repaired here: it still renders `[]` and needs fixing upstream.
 */
export function hoistArrayItemReferences(node) {
    if (Array.isArray(node)) {
        return node.map(hoistArrayItemReferences);
    }

    if (node === null || typeof node !== "object") {
        return node;
    }

    let hoistedNode = {};

    Object.keys(node).forEach(key => {
        hoistedNode[key] = hoistArrayItemReferences(node[key]);
    });

    if (hoistedNode.type === "array" && !!hoistedNode.$ref && hoistedNode.items === undefined) {
        const { $ref, ...arraySchema } = hoistedNode;

        return { ...arraySchema, items: { $ref } };
    }

    return hoistedNode;
}

export function swaggerUiSpecificationConverter(openApiSpecification) {
    // Order matters: `stripEmptyDefaults` first, because a surviving `"default": ""` outranks the
    // `items` that `hoistArrayItemReferences` adds and would collapse the example back to a string.
    let convertedSpecification = hoistArrayItemReferences(trimPropertyNames(stripEmptyDefaults(openApiSpecification)));
    let specificationPaths = convertedSpecification.paths;

    convertedSpecification.info.title = `${SwaggerUIBaseParams.title} (${backEndEnvironmentToUse().toLowerCase()})`;
    convertedSpecification.servers[0].url = BackEndEnvironmentUrls[backEndEnvironmentToUse()];
    convertedSpecification.paths = {};
    for (const [key, value] of Object.entries(specificationPaths)) {
        convertedSpecification.paths[key.replace("/api/", "/web/")] = value;
    }
    Object.keys(convertedSpecification.paths).map(path => {
        if (convertedSpecification.info.version === APIMajorVersions.v2) {
            convertedSpecification.paths[path].parameters[0].description = `${SwaggerUIBaseParams.apiVersionDescription} 'V2': '${APIV2MinorVersions["2025-06-01"]}, ${APIV2MinorVersions["2025-10-01"]}, ${APIV2MinorVersions["2025-11-01"]}, ${APIV2MinorVersions["2026-01-01"]}, ${APIV2MinorVersions["2026-03-01"]}, ${APIV2MinorVersions["2026-05-01"]}, ${APIV2MinorVersions["2026-05-16"]}, ${APIV2MinorVersions["2026-06-01"]}, ${APIV2MinorVersions["2026-07-01"]}, ${APIV2MinorVersions["2026-09-01"]}'`;
            convertedSpecification.paths[path].parameters[0].example = `${LATEST_V2_MINOR_VERSION}`;
        } else {
            convertedSpecification.paths[path].parameters[0].description = `${SwaggerUIBaseParams.apiVersionDescription} 'V1': '${APIV1MinorVersions["2023-01-01"]}, ${APIV1MinorVersions["2024-01-01"]}, ${APIV1MinorVersions["2024-03-01"]}, ${APIV1MinorVersions["2024-06-01"]}, ${APIV1MinorVersions["2024-08-01"]}, ${APIV1MinorVersions["2024-10-01"]}, ${APIV1MinorVersions["2025-05-01"]}, ${APIV1MinorVersions["2025-11-02"]}, ${APIV1MinorVersions["2026-01-02"]}'`;
            convertedSpecification.paths[path].parameters[0].example = `${LATEST_V1_MINOR_VERSION}`;
        };
        convertedSpecification.paths[path].get.parameters.map(parameter => {
            if (!!parameter.schema.description && !parameter.description) {
                parameter.description = parameter.schema.description
            }
        })
        convertedSpecification.paths[path].get.parameters.filter(param => param.name === "preferredLanguage")[0].description = SwaggerUIBaseParams.preferredLanguage;
        convertedSpecification.paths[path].get.parameters.filter(param => param.name === "extensions")[0].description = SwaggerUIBaseParams.extensions;
        convertedSpecification.paths[path].get.summary = undefined;
    })

    return convertedSpecification;
}